// src/pages/admin/AuditPage.jsx
import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { Search } from 'lucide-react'
import { adminAuditApi } from '../../api/services'
import { Card, CardBody, PageSpinner, Pagination } from '../../components/common/ui'

export default function AuditPage() {
  const [adminId, setAdminId] = useState('')
  const [action, setAction] = useState('')
  const [page, setPage] = useState(1)
  const { data, isLoading } = useQuery({ queryKey: ['admin-audit', adminId, action, page], queryFn: () => adminAuditApi.index({ admin_id: adminId||undefined, action: action||undefined, page }) })
  const { logs = {}, actions = [] } = data?.data?.data || {}
  const list = logs.data || []
  const lastPage = logs.last_page || 1

  return (
    <div>
      <h1 className="text-xl font-display font-bold mb-6">Audit Log</h1>
      <div className="flex gap-3 mb-4 flex-wrap">
        <input className="input" placeholder="Admin ID" type="number" value={adminId} onChange={e => { setAdminId(e.target.value); setPage(1) }} />
        <select className="input" value={action} onChange={e => { setAction(e.target.value); setPage(1) }}>
          <option value="">All actions</option>
          {actions.map(a => <option key={a} value={a}>{a}</option>)}
        </select>
      </div>
      {isLoading && <PageSpinner />}
      <div className="space-y-2">
        {list.map(log => (
          <Card key={log.id}>
            <CardBody className="py-3 flex items-center justify-between gap-4 text-sm">
              <div>
                <span className="font-medium">{log.action}</span>
                <span className="text-muted ml-2">by {log.admin?.name || `Admin #${log.admin_id}`}</span>
                {log.description && <p className="text-xs text-muted mt-0.5">{log.description}</p>}
              </div>
              <span className="text-xs text-muted whitespace-nowrap">{new Date(log.created_at).toLocaleString('en-IN')}</span>
            </CardBody>
          </Card>
        ))}
        {!isLoading && list.length === 0 && <p className="text-sm text-muted text-center py-8">No logs found.</p>}
      </div>
      {lastPage > 1 && <div className="mt-6"><Pagination currentPage={page} lastPage={lastPage} onPageChange={setPage} /></div>}
    </div>
  )
}
